// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Z_bb","active":"Z_dp","icon":"Z_cj"};